export function promiseAOP (
  originFun: Function,
  before?: Function,
  after?: Function
): any {
  function _ (this: Object, ...args: any) {
    let res: any;
    // 前置钩子
    try {
      before?.apply(this, args);
    } catch (e) {
      console.log('前置异常');
    }
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        res = await originFun.apply(this, args);
      } catch (e) {
        // 异常处理
        console.error(e);
        reject(e);
      }
      try {
        after?.apply(this, args);
      } catch (e) {
        console.log('后置异常');
      }
      resolve(res);
    });
  }
  return _;
}

export function normalAOP (
  originFun: Function,
  before?: Function,
  after?: Function
): any {
  function _ (this: Object, ...args: any) {
    let res: any;
    let next: boolean = true;
    // 前置钩子
    try {
      // eslint-disable-next-line no-unused-vars
      next = before?.apply(this, args);
    } catch (e) {
      console.log('前置异常');
    }
    if (next !== false) {
      res = originFun.apply(this, args);
      after?.apply(this, args);
    }
    // eslint-disable-next-line no-async-promise-executor, prefer-const
    return res;
  }
  return _;
}

export function mergeParams (params: object, options: any, field = 'content') {
  if (typeof options === 'object') {
    return Object.assign({ [field]: '' }, params, options);
  } else {
    return Object.assign(params, { [field]: `${options}` });
  }
}

export default { promiseAOP, normalAOP, mergeParams };
